module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    class: 'alert fade in alert-' + _vm.type
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.show = false
      }
    }
  }, [_vm._v("\n    ×\n  ")]), _vm._v(" "), _c('i', {
    class: 'fa-fw fa fa-' + _vm.icon
  }), _vm._v("\n  " + _vm._s(_vm.message) + "\n  "), (_vm.url.length) ? _c('router-link', {
    attrs: {
      "to": _vm.url
    }
  }, [_vm._v("Ver registro")]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cef5024"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Messages/Message.vue
// module id = 991
// module chunks = 1